import { render, staticRenderFns } from "./CreateCampaignAudience.vue?vue&type=template&id=5278f56a&scoped=true"
import script from "./CreateCampaignAudience.vue?vue&type=script&lang=js"
export * from "./CreateCampaignAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278f56a",
  null
  
)

export default component.exports